export const user = {
    "checkStores": "Ver unidades asociadas",
    "checkAgents ": "Ver jerarquía",
    "checkHierarchy": "Ver jerarquía",
    "checkSupervisors": "Ver supervisores asociados",
    "snackbar": {
      "create": {
        "success": "El usuario se creó exitosamente",
        "error": "Ocurrió un error al crear el usuario",
        "errorAssociate": "Ocurrió un error al asociar las unidades",
        "errorAssociates": "Ocurrió un error al asociar las unidades",
        "errorAssociateAgents": "Ocurrió un error al asociar los agentes",
        "errorAssociateUsers": "Ocurrió un error al asociar los usuarios"
      },
      "update": {
        "success": "El usuario se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar el usuario"
      }
    },
    "filter": {
      "title": "Usuarios",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar usuarios",
        "firstSelect": "Estatus del usuario",
        "rol": "Rol"
      }
    },
    "modal": {
      "search": "Buscar",
      "associateStore": "Unidades asociadas",
      "searchStore": "Buscar unidad",
      "associateAgents": "Agentes asociados",
      "userHierarchy": "Jerarquía del usuario",
      "searchAgents": "Buscar agentes",
      "searchUserHiersrchy": "Buscar usuarios",
      "searchSupervisors": "Buscar supervisores",
      "supervisors": "Supervisores",
      "associatedSupervisors": "Supervisores asociados",
      "agent": "Agente",
      "delete": {
        "title": "¿Está seguro que desea eliminar un usuario?",
        "description": "Al eliminar un usuario, se borrará de tu lista y debes realizar nuevamente su configuración",
        "success": {
          "DELETE": "El usuario se eliminó exitosamente",
          "1": "El usuario se activo exitosamente",
          "14": "El usuario se bloqueo exitosamente",
          "11": "El usuario se retiro exitosamente",
          "description": ""
        },
        "error": {
          "DELETE": "Hay un error y el usuario no puede ser eliminado",
          "1": "Hay un error y el usuario no se puede activar",
          "14": "Hay un error y el usuario no se puede bloquear",
          "11": "Hay un error y el usuario no se puede retirar",
          "description": ""
        }
      }
    },
    "informationCard": {
      "create": {
        "title": "Nuevo usuario",
        "admin": "Nuevo admin"
      },
      "edit": {
        "title": "Editar usuario",
        "admin": "Editar admin"
      },
      "buttons": {
        "add": "Agregar usuario",
        "addAdmin": "Agregar admin",
        "updateAdmin": "Actualizar admin",
        "cancel": "Cancelar",
        "edit": "Actualizar usuario",
        "editAdmin": "Editar admin"
      }
    }
  }